import { cn } from "@tellescope/ui";
import { EditorContent, useEditor } from "@tiptap/react";

import { createTemplateEditorExtensions } from "../editor/extensions";
import { htmlToEditorContent } from "../editor/serialization";
import { RICH_TEXT_CONTENT_CLASS } from "./richTextContentClass";

export interface TemplateRichTextPreviewProps {
  html: string;
  className?: string;
}

export const TemplateRichTextPreview = ({ html, className }: TemplateRichTextPreviewProps) => {
  const editor = useEditor(
    {
      editable: false,
      extensions: createTemplateEditorExtensions(),
      editorProps: { attributes: { class: RICH_TEXT_CONTENT_CLASS } },
      content: htmlToEditorContent(html),
    },
    [html]
  );

  return <EditorContent editor={editor} className={cn("overflow-y-auto", className)} />;
};
